import Achievements from './Achievements';

export default Achievements;
